import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

@Injectable({
    providedIn: 'root'
  })
  export class UserActivityLogService{
      constructor(
          private http: HttpClient,
          private apiService: ApiService
      ) { }
      public searchUserActivityLog(userActivityLogSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(userActivityLogSearchParam);
        return this.apiService.post(`ReportUserActivityLog/Summary`,userActivityLogSearchParam)
      }
      public exportUserActivityLogReport(userActivityLogSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ReportUserActivityLog/ExportUserActivityLogReport`,
        userActivityLogSearchParam ,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  }